module.exports = __webpack_public_path__ + "assets/img/2K@2x.a66fa05f.png";